// extracted by mini-css-extract-plugin
export default {"shadow":"sticker_shadow__BYY48","border":"sticker_border__u5OBw","wrapper":"sticker_wrapper__wcwBh"};